import { useNotify, useTranslate, useUpdate } from "ra-core";
import { useState } from "react";

import type { CompanyNote } from "../types";

// «Fullfør oppfølging» (Macro-planen, trinn 3): fjerner notatets
// oppfølgingsdato så det forsvinner fra «Å gjøre». Teksten og resten av
// notatet røres ikke. Brukes både i «Å gjøre» og på kundekortets notater.
//
// Pessimistisk: raden skal ikke forsvinne før lagringen er bekreftet, og en
// feil skal vises tydelig i stedet for å angres i det stille.
export const useCompleteFollowUp = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const [update] = useUpdate<CompanyNote>();
  const [pendingId, setPendingId] = useState<CompanyNote["id"] | null>(null);

  const complete = (note: CompanyNote, onDone?: () => void) => {
    setPendingId(note.id);
    update(
      "company_notes",
      {
        id: note.id,
        data: { follow_up_date: null },
        previousData: note,
      },
      {
        mutationMode: "pessimistic",
        onSuccess: () => {
          setPendingId(null);
          notify("crm.company_notes.follow_up_completed", {
            type: "success",
            messageArgs: { _: "Oppfølgingen er fullført" },
          });
          onDone?.();
        },
        onError: (error) => {
          setPendingId(null);
          const detail = (error as Error)?.message;
          notify(
            translate("crm.company_notes.follow_up_complete_failed", {
              _: "Kunne ikke fullføre oppfølgingen. Den står fortsatt i Å gjøre.",
            }) + (detail ? ` (${detail})` : ""),
            { type: "error" },
          );
        },
      },
    );
  };

  return {
    complete,
    isPending: (note: CompanyNote) =>
      pendingId != null && String(pendingId) === String(note.id),
  };
};
